import React from "react";
import MaterialSnack from "./materialsnack";
export default class NewSnackbar extends React.Component {
  render() {
    const { snack, handleClose } = this.props;
    // console.log("class snack", snack);
    return (
      <div>
        <MaterialSnack
          open={snack.open}
          type={snack.type}
          message={snack.message}
          handleClose={handleClose}
        />
      </div>
    );
  }
}
